import { api } from '../lib/api'

export type JobsHubTabStatus = 'pending' | 'active' | 'completed' | 'disputed' | 'cancelled' | 'all'

export type JobsHubUser = {
  id: number
  handle: string
  display_name: string
  avatar_url?: string
}

export type JobsHubItem = {
  id: number
  post_id: number
  title: string
  summary?: string
  job_kind: 'CONTRACT' | 'EMPLOYMENT'
  job_mode?: 'REMOTE' | 'LOCAL'
  job_visibility: 'OPEN' | 'DIRECT'
  status: string
  invitation_status?: 'PENDING' | 'ACCEPTED' | 'DECLINED' | null
  escrow_status?: 'NONE' | 'HELD' | 'RELEASED' | 'REFUNDED' | null
  escrow_amount_pixe?: number | null
  urgency?: 'FLEXIBLE' | 'TODAY' | 'ASAP' | null
  scheduled_for?: string | null
  created_at?: string
  updated_at?: string
  client?: JobsHubUser | null
  pro?: JobsHubUser | null
  thread_id?: number | null
  proposal_count?: number
}

export type JobsHubResponse = {
  count: number
  page: number
  page_size: number
  tab_status: string
  results: JobsHubItem[]
}

type JobsHubParams = {
  tab_status?: JobsHubTabStatus
  q?: string
  page?: number
  page_size?: number
  signal?: AbortSignal
}

export async function listMyJobs(params: JobsHubParams = {}) {
  const { signal, ...query } = params
  const { data } = await api.get<JobsHubResponse>('/api/jobs/mine/', { params: query, signal })
  return data
}

export async function listAssignedJobs(params: JobsHubParams = {}) {
  const { signal, ...query } = params
  const { data } = await api.get<JobsHubResponse>('/api/jobs/assigned/', { params: query, signal })
  return data
}

